import { ExtractedTargetInfo, TargetTypeEnum } from './extractTargetInfo';
import { ShipInfo } from './shipInfo';
import { AutoCompleteShipInfo } from './autoCompleteShip';

/**
 * Fills missing ship identification fields from search result data.
 *
 * The detail panel fetches ship info from a different backend endpoint
 * than the search. When the backend response is missing fields (e.g. name),
 * this fills them from the search result the user originally clicked.
 *
 * Only fills gaps — never overwrites existing backend data.
 * Only applies to Ship-type targets with a matching MMSI.
 */
export function fillMissingFieldsFromSearch(
  result: ExtractedTargetInfo,
  searchData: AutoCompleteShipInfo | null,
): void {
  if (!searchData || result.extractedTargetInfoType !== TargetTypeEnum.Ship) {
    return;
  }

  for (const info of result.extractedTargetInfo as ShipInfo[]) {
    // Only fill fields for the same vessel — prevent cross-contamination
    if (!searchData.mmsi || info.mmsi !== searchData.mmsi) continue;

    if (!info.name && searchData.name) info.name = searchData.name;
    if (!info.imo && searchData.imo) info.imo = String(searchData.imo);
    if (!info.callSign && searchData.callSign)
      info.callSign = searchData.callSign;
    if (!info.shipType && searchData.type) info.shipType = searchData.type;
  }
}
